import { Route } from "react-router-dom";
import { SuggestionFeed } from "./SuggestionFeed";

export const routes = (
  <>
    <Route path="/feed/:slug" element={<SuggestionFeed />} />
    <Route path="/feed" element={<SuggestionFeed />} />
  </>
);
